export const RESPONSE_ROW_SIZE = 13;
